import { useEffect, useReducer } from 'react'
import { AnyAction } from 'redux'
import { GET_SUPPLIER_QUALIFICATIONS } from '../../api/MaterialApi'
import { getSupplierId, isResponseCodeSuccess } from '../../tools/util'

// action 类型定义
const QUALIFICATION_ACTION_TYPE = {
  SET_DATA: 'QUALIFICATION/SET_DATA', // 数据
  SET_LOADING: 'QUALIFICATION/SET_LOADING', // loading
}

interface CooperationState {
  dataSource: any[]
  loading: boolean
}

const defaultState: CooperationState = {
  dataSource: [],
  loading: false,
}

// 默认 Reducer
const reducer = (state = defaultState, action: AnyAction) => {
  const arr = { ...state }
  switch (action.type) {
    case QUALIFICATION_ACTION_TYPE.SET_DATA:
      arr.dataSource = action.value
      return arr
    case QUALIFICATION_ACTION_TYPE.SET_LOADING:
      arr.loading = action.value
      return arr
    default:
      return state
  }
}

const setDataAction = (params: any[]) => ({
  type: QUALIFICATION_ACTION_TYPE.SET_DATA,
  value: params,
})

const setLoadingAction = (params: boolean) => ({
  type: QUALIFICATION_ACTION_TYPE.SET_LOADING,
  value: params,
})

const useQualificationsHooks = () => {
  const [state, dispatch] = useReducer(reducer, defaultState)
  const { dataSource, loading } = state

  useEffect(() => {
    getLicence()
  }, [])

  // 获取数据
  const getLicence = async () => {
    dispatch(setLoadingAction(true))
    const res = await GET_SUPPLIER_QUALIFICATIONS({
      supplierId: getSupplierId(),
    })
    if (isResponseCodeSuccess(res.code)) {
      dispatch(setDataAction(res.data))
    }
    dispatch(setLoadingAction(false))
  }

  const onRefresh = () => {
    getLicence()
  }

  return {
    dataSource,
    loading,
    onRefresh,
  }
}

export default useQualificationsHooks
import { useEffect, useReducer } from 'react'
import { AnyAction } from 'redux'
import { GET_SUPPLIER_QUALIFICATIONS } from '../../api/MaterialApi'
import { getSupplierId, isResponseCodeSuccess } from '../../tools/util'

// action 类型定义
const QUALIFICATION_ACTION_TYPE = {
  SET_DATA: 'QUALIFICATION/SET_DATA', // 数据
  SET_LOADING: 'QUALIFICATION/SET_LOADING', // loading
}

interface CooperationState {
  dataSource: any[]
  loading: boolean
}

const defaultState: CooperationState = {
  dataSource: [],
  loading: false,
}

// 默认 Reducer
const reducer = (state = defaultState, action: AnyAction) => {
  const arr = { ...state }
  switch (action.type) {
    case QUALIFICATION_ACTION_TYPE.SET_DATA:
      arr.dataSource = action.value
      return arr
    case QUALIFICATION_ACTION_TYPE.SET_LOADING:
      arr.loading = action.value
      return arr
    default:
      return state
  }
}

const setDataAction = (params: any[]) => ({
  type: QUALIFICATION_ACTION_TYPE.SET_DATA,
  value: params,
})

const setLoadingAction = (params: boolean) => ({
  type: QUALIFICATION_ACTION_TYPE.SET_LOADING,
  value: params,
})

const useQualificationsHooks = () => {
  const [state, dispatch] = useReducer(reducer, defaultState)
  const { dataSource, loading } = state

  useEffect(() => {
    getLicence()
  }, [])

  // 获取数据
  const getLicence = async () => {
    dispatch(setLoadingAction(true))
    const res = await GET_SUPPLIER_QUALIFICATIONS({
      supplierId: getSupplierId(),
    })
    if (isResponseCodeSuccess(res.code)) {
      dispatch(setDataAction(res.data))
    }
    dispatch(setLoadingAction(false))
  }

  const onRefresh = () => {
    getLicence()
  }

  return {
    dataSource,
    loading,
    onRefresh,
  }
}

export default useQualificationsHooks
